import styled from 'styled-components';

export const NotFoundBlock = styled.section`
    padding: 5.5rem 0 3rem;
`;